import { createContext, useContext, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { useAuth } from './AuthContext';

const UsersContext = createContext();

export function UsersProvider({ children }) {
  const { currentUser } = useAuth();

  useEffect(() => {
    const createUserDocument = async () => {
      if (!currentUser) return;

      const userRef = doc(db, 'users', currentUser.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        try {
          await setDoc(userRef, {
            uid: currentUser.uid,
            email: currentUser.email,
            displayName: currentUser.displayName || currentUser.email.split('@')[0],
            friends: [],
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          });
        } catch (error) {
          console.error('Error creating user document:', error);
        }
      }
    };

    createUserDocument();
  }, [currentUser]);

  return (
    <UsersContext.Provider value={{}}>
      {children}
    </UsersContext.Provider>
  );
}

export function useUsers() {
  return useContext(UsersContext);
} 